export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-900">
            关于我们
          </h2>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-10">
          <div className="max-w-[720px] mx-auto">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              <strong className="text-foreground-900">黑料视频</strong>是由<strong className="text-foreground-900">体内精69xxxxx黑料社</strong>倾力打造的全天候黑料社区平台。我们致力于为全网用户提供最新、最全、最真实的第一手爆料视频与内幕追踪内容。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              平台保持<strong className="text-foreground-900">24小时不间断更新</strong>机制，涵盖娱乐圈、商业界、科技圈、网红圈、综艺界等多个领域的独家爆料与深度调查。黑料社区汇聚了超过50万活跃用户，大家在这里自由讨论、分享观点、追踪热点。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              我们坚持<strong className="text-foreground-900">免费开放</strong>原则，所有视频内容无需注册即可在线观看。同时严格保护投稿人隐私，确保每一条有价值的信息都能安全地传递给公众。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              黑料视频与<strong className="text-foreground-900">黑料社区</strong>正在不断成长，欢迎每一位关注真相、热爱爆料的用户加入我们，共同打造最具影响力的黑料信息平台。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-8 border-t border-background-200/70">
            {[
              { num: '2400+', label: '累计爆料视频' },
              { num: '500+', label: '独家专题报道' },
              { num: '50万+', label: '社区活跃用户' },
              { num: '24h', label: '全天候更新' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-xl md:text-2xl font-extrabold font-heading text-primary-600">{stat.num}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}